import styled from 'styled-components';
import { rem } from 'polished';
import { applyStyleModifiers, styleModifierPropTypes } from 'styled-components-modifiers';

const modifierConfig = {
  // Types
  plain: ({ theme }) => `
    border: none;
    border-radius: 0;
    font-family: ${theme.fonts.primary};
    font-weight: 600;
    font-size: 1rem;
    padding: 0;

    &:hover {
      background-color: transparent;
      color: ${theme.palette.primary[0]};
    }
  `,

  primary: ({ theme }) => `
    color: white;
    background-color: ${theme.palette.primary[0]};

    &:hover {
      background-color: white;
      color: ${theme.palette.primary[0]};
    }
  `,

  danger: ({ theme }) => `
    border-color: ${theme.palette.primary[1]};
    color: ${theme.palette.primary[1]};

    &:hover {
      background-color: ${theme.palette.primary[1]};
      color: white;
    }
  `,

  success: ({ theme }) => `
    color: white;
    border-color: ${theme.palette.primary[2]};
    background-color: ${theme.palette.primary[2]};

    &:hover {
      background-color: white;
      color: ${theme.palette.primary[2]};
    }
  `,

  // Sizes
  'x-small': () => `
    font-size: ${rem('12px')};
    padding: 6px 12px;
    font-weight: 600;
  `,

  small: () => `
    font-size: ${rem('14px')};
    padding: 6px 14px;
    font-weight: 600;
  `,

  large: () => `
    font-size: ${rem('22px')};
    padding: 10px 28px;
  `,
};

const Button = styled.button.attrs({
  type: 'button',
})`
  border: 1px solid ${(props) => props.theme.palette.primary[0]};
  border-radius: 100px;
  font-family: ${(props) => props.theme.fonts.primary};
  font-weight: 700;
  font-size: ${rem('18px')};
  color: ${(props) => props.theme.palette.primary[0]};
  padding: 9px 24px;
  cursor: pointer;
  transition: all 0.15s;
  background-color: white;

  &:hover {
    background-color: ${(props) => props.theme.palette.primary[0]};
    color: white;
  }

  ${applyStyleModifiers(modifierConfig)};
`;

Button.propTypes = {
  modifiers: styleModifierPropTypes(modifierConfig),
};

export default Button;
